import { Component, HostListener } from '@angular/core';
import { AccountsLoginService } from './modules/accounts-module/accounts/services/accounts-login-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private l_accountsLoginService: AccountsLoginService) {}

  public sessionStorage: Storage = sessionStorage;


  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    // event.preventDefault();
  }

  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent) {
    console.log('restore configs post refresh-reload');
    
    let l_userDetails = JSON.parse(this.sessionStorage.getItem('system_params'));
    console.log('l_userDetails on refresh-reload ===> ', l_userDetails);
    if(l_userDetails !== null) {
      console.log('call convey login status to fix login observable');  
      this.l_accountsLoginService.lFN_ConveyLoginStatus(false);
    }
  }

}
